module.exports = __webpack_public_path__ + "8a5356e9/img/note-list-icon.961c1485.svg";